import { isNoCreditCardTrialEnabled } from '@lingoda/monolith-feature-flags';
import { useUserSubscriptionsQuery } from '@lingoda/monolith-graphql';

// TODO: Ones experiment success and removed, rename it to `useIsInTrial`
export const useBookWithoutPaymentAvailable = () => {
    const { data, loading } = useUserSubscriptionsQuery();

    const isInTrial = !!data?.subscriptions?.currentSubscription?.isInTrial;

    return {
        loading,
        bookWithoutPaymentAvailable: isInTrial && isNoCreditCardTrialEnabled(),
    };
};
